(()=>{
 const dialog=document.querySelector('.cil-mobile-zoom');if(!dialog)return;
 const mobile=matchMedia('(max-width:767px)'),photos=dialog.querySelector('.cil-mobile-zoom__photos');
 const zooms=[];
 let opener=null,savedY=0,oldBody=null,initialized=false,gesture=null,suppressUntil=0;
 const close=()=>{if(dialog.open)dialog.close()};
 const initialize=()=>{
  if(initialized||!window.PinchZoom?.default)return;
  dialog.querySelectorAll('.cil-mobile-zoom__image').forEach(image=>{
   zooms.push(new window.PinchZoom.default(image,{draggableUnzoomed:false,minZoom:1,maxZoom:4,tapZoomFactor:1}));
  });initialized=true;
 };
 document.addEventListener('click',e=>{
  const image=e.target.closest('.js-mobile-product-images .click_zoom');
  if(!image||!mobile.matches)return;
  e.preventDefault();e.stopImmediatePropagation();
  if(performance.now()<suppressUntil)return;
  opener=image;savedY=window.scrollY;
  oldBody={position:document.body.style.position,top:document.body.style.top,width:document.body.style.width};
  Object.assign(document.body.style,{position:'fixed',top:`-${savedY}px`,width:'100%'});
  dialog.showModal();initialize();
  zooms.forEach(zoom=>{zoom.stopAnimation();zoom.zoomFactor=1;zoom.setupOffsets();zoom.update()});
  const frame=dialog.querySelector(`[data-cil-zoom-index="${Number(image.dataset.cilPhotoIndex)||0}"]`);
  requestAnimationFrame(()=>{photos.scrollTop=frame?.offsetTop||0});
 },true);
 // Observe gestures in capture phase, before the pinch library stops propagation.
 document.addEventListener('touchstart',e=>{
  if(!dialog.open&&!e.target.closest('.js-mobile-product-images'))return;
  const t=e.touches[0];if(!t)return;
  if(e.touches.length>1){if(gesture)gesture.moved=true;suppressUntil=performance.now()+600;return}
  gesture={x:t.clientX,y:t.clientY,moved:false};
 },{capture:true,passive:true});
 document.addEventListener('touchmove',e=>{
  if(!gesture)return;const t=e.touches[0];
  if(e.touches.length>1||Math.hypot(t.clientX-gesture.x,t.clientY-gesture.y)>10)gesture.moved=true;
 },{capture:true,passive:true});
 const finish=e=>{if(gesture?.moved)suppressUntil=performance.now()+500;if(!e.touches.length)gesture=null};
 document.addEventListener('touchend',finish,{capture:true,passive:true});
 document.addEventListener('touchcancel',e=>{suppressUntil=performance.now()+500;gesture=null},{capture:true,passive:true});
 photos.addEventListener('click',e=>{if(e.target.closest('img')&&performance.now()>=suppressUntil)close()},true);
 dialog.addEventListener('close',()=>{
  if(oldBody)Object.assign(document.body.style,oldBody);
  window.scrollTo(0,savedY);opener?.focus({preventScroll:true});
 });
 mobile.addEventListener('change',()=>{if(!mobile.matches)close()});
})();
